








export default {
    name: "app",
    data() {
        return {
            inactivityTimerId: null
        }
    },
    components: {
        Header: () => import('./components/Header.component.vue'),
        SubHeader: () => import('./components/SubHeader.component.vue'),
        MainContent: () => import('./components/MainContent.component.vue')
    },
    created() {
        this.$root.$on('initInactivityTimer', this.setupInactivityTimers);    
    },
    beforeDestroy() {
        clearInterval(this.reportFlashTimer);      
        document.removeEventListener("keypress", this.resetInactivityTimer);
        document.removeEventListener("mousemove", this.resetInactivityTimer);
        document.removeEventListener("mousedown", this.resetInactivityTimer);
        document.removeEventListener("touchmove", this.resetInactivityTimer);
    },
    methods: {
        handleInactive() {
            clearTimeout(this.inactivityTimerId);
            this.$root.$emit("showBestTimberByCost");
            document.removeEventListener("keypress", this.resetInactivityTimer);
            document.removeEventListener("mousemove", this.resetInactivityTimer);
            document.removeEventListener("mousedown", this.resetInactivityTimer);
            document.removeEventListener("touchmove", this.resetInactivityTimer);
        },
        startInactivityTimer() {
            var _t = this;
            this.inactivityTimerId = setTimeout(function () {
                _t.handleInactive()
            }, 10000);  //10 seconds
        },
        resetInactivityTimer() {
            if (this.inactivityTimerId) {
                clearTimeout(this.inactivityTimerId);
                this.startInactivityTimer();
            }
        },
        setupInactivityTimers() {
            document.addEventListener("keypress", this.resetInactivityTimer);
            document.addEventListener("mousemove", this.resetInactivityTimer);
            document.addEventListener("mousedown", this.resetInactivityTimer);
            document.addEventListener("touchmove", this.resetInactivityTimer);
            this.startInactivityTimer();
        },
    }

}
